function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 6L6 31M6 6l26 25",
  stroke: "currentColor",
  strokeWidth: 8,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
});

var SvgPostponed = function SvgPostponed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 37"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzggMzciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iOCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj4KICAgIDxwYXRoIGQ9Ik0zMiA2TDYgMzFNNiA2bDI2IDI1Ii8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgPostponed as ReactComponent };